<div class="container">
  <div class="row justify-content-center">
    <div class="col-md-8">
      <div class="card mt-5 shadow-lg">
        <div class="card-body text-center bg-primary text-white rounded-3">
          <h1 class="card-title display-4">🎉 Thank you!</h1>
          <p class="lead">
            Your subscription is confirmed. Welcome to our service!
          </p>
          <p>
            Explore the features below to get started.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4">
  <div class="row row-cols-1 row-cols-md-2 g-4">
    <div class="col">
      <div class="card h-100 card-hover shadow">
        <div class="card-body text-center">
          <i class="bi bi-house-fill text-primary" style="font-size: 2rem;"></i>
          <h5 class="card-title mt-3">Property Management</h5>
          <p class="card-text">Easily manage all your properties in one place.</p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card h-100 card-hover shadow">
        <div class="card-body text-center">
          <i class="bi bi-people-fill text-primary" style="font-size: 2rem;"></i>
          <h5 class="card-title mt-3">Tenant Management</h5>
          <p class="card-text">Keep track of your tenants and their tenancies.</p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card h-100 card-hover shadow">
        <div class="card-body text-center">
          <i class="bi bi-tools text-primary" style="font-size: 2rem;"></i>
          <h5 class="card-title mt-3">Maintenance Tracking</h5>
          <p class="card-text">Schedule and track maintenance jobs for your properties.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .card-hover {
    transition: transform 0.3s ease-in-out;
  }

  .card-hover:hover {
    transform: scale(1.05);
  }
</style>
